import React, { Fragment, useState, useRef, useEffect } from "react"

import { MuiColorInput } from 'mui-color-input'
import { CLASSNAME_FOR_WIDTH } from '../../constant/bannerItems'
import DeleteIcon from '@mui/icons-material/Delete'
import MuiAlert from '@mui/material/Alert';
import "./editablestyles.css";
import { 
    List,
    ListItem, 
    ListItemText, 
    TextField, 
    Button, 
    FormControl, 
    Select, 
    MenuItem ,
    styled
} from "@mui/material"

import JoditEditor from "jodit-react";
import TextEditorConfig from "../../helpers/TextEditor";

const StyledFormControl = styled(FormControl)({
    width: '40ch',
});

const StyledTextField = styled(TextField)({
    width: '40ch',
});



const ActionGridForm = ({ actionGridId, tempTitle, tempDesc, resetSettings, handleFileInputChange, handleCheckboxInputChange, setImage, isLoading, handleClose, inputs, handleInputChange, handleColorPicker, resetColor, handleSubmit, errors, fromEditAction, deleteImage, tempImage, tempTitleImage }) => {


    const [temp, setTemp] = useState("")

    const onSubmit = () => {
        handleSubmit()
    }

    const editor = useRef(null)

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    return (
            <div className="banner-form" style={{ 'minHeight': '52vh' }}>
                <div className="">

                    <form className="banner-form-style">
                        <List>
                            {fromEditAction === 'title' && (
                                <>
                                    <div className="row">
                                        <div className="col-lg-12 mt-35">
                                            <Alert severity="info" className="mb-35"><p>If you have idea about css. You can use source code in text-ediotr. Click on <b>&lt;/&gt;</b></p>
                                                <p>You know about google editor or any other then you can play with text-editor for text style</p>
                                                <p>You don't know about any style or text-editor, then simply type text in editor. Select below options for design. Like color, font size and font family </p></Alert>
                                            <Alert severity="warning">
                                                <p>// Write your Css here</p>
                                                <p>// Please be aware making changes here will change the code </p>
                                                <p>// Do not delete original code</p>
                                            </Alert>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-4 mt-35">
                                            <label style={{ 'fontSize': '1.1rem' }}>Title </label>
                                        </div>
                                        <div className="col-lg-8 mt-35">
                                            <JoditEditor
                                                ref={editor}
                                                value={inputs.title}
                                                config={TextEditorConfig}
                                                tabIndex={1}
                                                onChange={(bodyOfEditor) => {
                                                    inputs.title = bodyOfEditor
                                                    setTemp('0');
                                                }}
                                            />
                                        </div>
                                    </div>


                                    <div className="row">
                                        <div className="col-lg-4 mt-35">
                                            <ListItemText id="switch-list-label-wifi" primary="Box Width" />
                                        </div>
                                        <div className="col-lg-8 mt-35">
                                            <FormControl variant="outlined" className='w-100'>
                                                <Select labelId="demo-simple-select-outlined-label" value={inputs.descriptionWidth}
                                                    onChange={handleInputChange}
                                                    name="descriptionWidth">
                                                    {CLASSNAME_FOR_WIDTH && CLASSNAME_FOR_WIDTH.length && Object.keys(CLASSNAME_FOR_WIDTH).map((data, index) => {
                                                        return <MenuItem value={CLASSNAME_FOR_WIDTH[data].value}> {CLASSNAME_FOR_WIDTH[data].label}</MenuItem>
                                                    })}
                                                    {!CLASSNAME_FOR_WIDTH.length && (<MenuItem value=" "> No Width</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                </>
                            )}
                            {fromEditAction === 'description' && (
                                <>
                                    <div className="row">
                                        <div className="col-lg-12 mt-35">
                                            <Alert severity="info" className="mb-35"><p>If you have idea about css. You can use source code in text-ediotr. Click on <b>&lt;/&gt;</b></p>
                                                <p>You know about google editor or any other then you can play with text-editor for text style</p>
                                                <p>You don't know about any style or text-editor, then simply type text in editor. Select below options for design. Like color, font size and font family </p></Alert>
                                            <Alert severity="warning">
                                                <p>// Write your Css here</p>
                                                <p>// Please be aware making changes here will change the code </p>
                                                <p>// Do not delete original code</p>
                                            </Alert>
                                        </div>
                                    </div>
                                    <div className="row mt-35">
                                        <div className="col-lg-12 mt-35">
                                            <JoditEditor
                                                ref={editor}
                                                value={inputs.description}
                                                config={TextEditorConfig}
                                                tabIndex={1}
                                                onChange={(bodyOfEditor) => {
                                                    inputs.description = bodyOfEditor
                                                    setTemp('0');
                                                }}
                                            />
                                        </div>

                                    </div>


                                </>
                            )}

                            {fromEditAction === 'bgColor' && (
                                <ListItem className="mb-35">
                                    <ListItemText id="switch-list-label-wifi" primary="Background color" />
                                    <div className="col-lg-4">
                                        <MuiColorInput
                                            name="bgColor"
                                            defaultValue="#000"
                                            format="hex"
                                            value={inputs.bgColor}
                                            onChange={color => { handleColorPicker('bgColor', color) }}
                                        />
                                    </div>
                                    <div className="col-lg-3 d-flex align-items-center">
                                        <p>{inputs.bgColor != undefined && (inputs.bgColor)}</p>
                                        {inputs.bgColor != undefined &&
                                            inputs.bgColor != "undefined" &&
                                            inputs.bgColor != "" && (<DeleteIcon
                                                className="text-error"
                                                title={"Delete"}
                                                onClick={() => {
                                                    resetColor("", 'bgColor')
                                                }}
                                                aria-label=""
                                            />)}
                                    </div>
                                </ListItem>
                            )}
                            {fromEditAction === 'image' && (
                                <>
                                    <ListItem className={`mt-35 mb-35`} style={{ height: "5em" }}
                                     secondaryAction={
                                          <StyledFormControl variant="outlined" >
                                                <div className="uploadedImg">
                                                    <input onChange={handleFileInputChange}
                                                        type="file"
                                                        name="image"
                                                    />
                                                    {tempImage != "" && tempImage != 'undefined' && (
                                                        <>
                                                            <img height="50px" width="50px" src={tempImage} className="mt-15"></img>
                                                            <DeleteIcon
                                                                className="text-error"
                                                                title={"Delete"}
                                                                onClick={() => {
                                                                    setImage("", 'image')
                                                                    deleteImage('image')
                                                                }}
                                                                aria-label=""
                                                            />
                                                        </>
                                                    )}
                                                </div>
                                          </StyledFormControl>
                                    }>
                                        <ListItemText id="switch-list-label-wifi" primary="Icon Image" />
                                       
                                    </ListItem>
                                    <ListItem className="mb-35 mt-55" 
                                        secondaryAction={
                                            <>
                                                <StyledTextField
                                                    id="standard-number"
                                                    type="number"
                                                    slotProps={{
                                                        inputLabel: {
                                                            shrink: true
                                                        }
                                                    }}
                                                    size="medium"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={inputs.imageWidth}
                                                    onChange={handleInputChange}
                                                    name="imageWidth"
                                                /><span className="px-text">PX</span>
                                            </>
                                        }
                                    >
                                        <ListItemText id="switch-list-label-wifi" primary="Icon Width" />
                                       
                                    </ListItem>
                                    <ListItem className="mb-35 mt-35"
                                    secondaryAction={
                                        <>
                                            <StyledTextField
                                                id="standard-number"
                                                type="number"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: true
                                                    }
                                                }}
                                                size="medium"
                                                variant="outlined"
                                                fullWidth
                                                value={inputs.imageHeight}
                                                onChange={handleInputChange}
                                                name="imageHeight"
                                            /><span className="px-text">PX</span>
                                        </>
                                    }
                                    >
                                        <ListItemText id="switch-list-label-wifi" primary="Icon Height" />
                                    </ListItem>

                                </>
                            )}
                            {fromEditAction === 'titleImage' && (
                                <>
                                    <ListItem className="mb-55" 
                                            secondaryAction={
                                            <StyledFormControl variant="outlined" >
                                                <Select labelId="demo-simple-select-outlined-label" value={inputs.descriptionWidth}
                                                    onChange={handleInputChange}
                                                    name="descriptionWidth">
                                                    {CLASSNAME_FOR_WIDTH && CLASSNAME_FOR_WIDTH.length && Object.keys(CLASSNAME_FOR_WIDTH).map((data, index) => {
                                                        return <MenuItem value={CLASSNAME_FOR_WIDTH[data].value}> {CLASSNAME_FOR_WIDTH[data].label}</MenuItem>
                                                    })}
                                                    {!CLASSNAME_FOR_WIDTH.length && (<MenuItem value=" "> No Width</MenuItem>)}
                                                </Select>
                                            </StyledFormControl>  
                                            }
                                    >
                                        <ListItemText id="switch-list-label-wifi" primary="Box Width" />
                                    </ListItem>
                                    <ListItem className={`mt-35 mb-35`}
                                     style={{ height: "5em" }}
                                     secondaryAction={
                                        <StyledFormControl variant="outlined" >
                                            <div className="uploadedImg">
                                                <input onChange={handleFileInputChange}
                                                    type="file"
                                                    name="titleImage"
                                                />
                                                {tempTitleImage != "" && tempTitleImage != 'undefined' && (
                                                    <>
                                                        <img height="50px" width="50px" src={tempTitleImage} className="mt-15"/>
                                                        <DeleteIcon
                                                            className="text-error"
                                                            title={"Delete"}
                                                            onClick={() => {
                                                                setImage("", 'titleImage')
                                                                deleteImage('titleImage')
                                                            }}
                                                            aria-label=""
                                                        />
                                                    </>
                                                )}
                                            </div>
                                        </StyledFormControl>   
                                     }
                                    >
                                        <ListItemText id="switch-list-label-wifi" primary="Title Image" />
                                       
                                    </ListItem>
                                    <ListItem className="mb-35 mt-55"
                                              secondaryAction={
                                                <>
                                                    <StyledTextField
                                                            id="standard-number"
                                                            type="number"
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: true
                                                                }
                                                            }}
                                                            size="medium"
                                                            variant="outlined"
                                                            fullWidth
                                                            value={inputs.titleImageWidth}
                                                            onChange={handleInputChange}
                                                            name="titleImageWidth"
                                                        /><span className="px-text">PX</span>
                                                </>
                                              }
                                    >
                                        <ListItemText id="switch-list-label-wifi" primary="Title Image Width" />
                                    </ListItem>
                                    <ListItem className="mb-35 mt-35"
                                     secondaryAction={
                                        <>
                                            <StyledTextField
                                                id="standard-number"
                                                type="number"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: true
                                                    }
                                                }}
                                                size="medium"
                                                variant="outlined"
                                                fullWidth
                                                value={inputs.titleImageHeight}
                                                onChange={handleInputChange}
                                                name="titleImageHeight"
                                            /><span className="px-text">PX</span>
                                        </>
                                     }
                                    >
                                        <ListItemText id="switch-list-label-wifi" primary="Title Image Height" />
                                    </ListItem>
                                </>
                            )}
                            <ListItem>
                                <button type="button" className="cancelButton" onClick={() => { handleClose() }}>Cancel</button>&nbsp;&nbsp;&nbsp;
                                <Button variant="contained" color="primary" className="bannerbutton" type="button" onClick={() => { onSubmit() }}> {actionGridId ? "Update" : "Save"}</Button>

                            </ListItem>
                        </List>

                    </form>
                </div>
            </div>
    )

};

export default ActionGridForm;
